import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import ToastMsg from "../../components/ToastMsg";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import Breadcrumb from "../../components/Breadcrumb";
import CTAs from "../../components/CTAs";
import Toggle from "../../components/Toggle";
import RadioButton from "../../components/RadioButton";
import Footer from "../../components/Footer";
import SettingNav from "../../components/settingNav";

const SettingsLBAConfigPage = () => {
  const navigate = useNavigate();
  const [isToastMsgOpen, setToastMsgOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);

  const openToastMsg = useCallback(() => {
    setToastMsgOpen(true);
  }, []);

  const closeToastMsg = useCallback(() => {
    setToastMsgOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const handleToggle = (state) => {
    console.log("Toggle state is:", state);
  };

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-ff-heading-1">
        <NavigationPanel />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 px-4 md:px-4 lg:px-24 box-border">
          <div className="self-stretch flex flex-col items-start justify-start gap-6 text-9xl text-primary-primary-900">
            {/* Heading */}
            <div className="self-stretch bg-white border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex flex-col items-start justify-start pt-0 px-0 pb-6 gap-1.5">
              <b className="relative">Settings</b>
              <div className="relative text-base text-neutrals-neutral-300">
                Get your billing information, generate/review invoices.
              </div>
            </div>

            <div className="self-stretch flex flex-row items-start justify-start gap-8 text-base text-neutrals-neutral-300">
              {/* Tabs */}
              <SettingNav />

              <div className="w-full flex-1 self-stretch flex flex-col items-start justify-start gap-6 text-lg text-neutrals-neutral-900">
                <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex flex-row items-start justify-between pt-0 px-0 pb-6 gap-0">
                  <div className="flex flex-col items-start justify-start gap-1.5">
                    <div className="relative font-semibold">
                      Pre-LBA configuration
                    </div>
                    <div className="relative text-sm text-neutrals-neutral-300">
                      Allow users to configure how and when communication is
                      initiated with debtors.
                    </div>
                  </div>
                  <div className="flex flex-row items-start justify-start gap-3 text-sm">
                    <CTAs
                      type="Ghostbtn"
                      text="Cancel"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      position="relative"
                    />

                    <CTAs
                      type="Primarybtn"
                      text="Save"
                      textColor="text-neutrals-neutral-50"
                      bgColor="bg-primary-primary-500"
                      borderColor="border-primary-primary-500"
                      position="relative"
                      onClick={openToastMsg}
                    />
                  </div>
                </div>

                <div className="self-stretch flex flex-col items-start justify-start gap-8 text-base">
                  <div className="self-stretch flex flex-col items-start justify-start gap-6">
                    <div className="self-stretch relative font-semibold">
                      Pre-LBA settings
                    </div>
                    <div className="self-stretch flex flex-col items-start justify-start gap-6 text-sm">
                      <div className="self-stretch flex flex-col items-start justify-start gap-2.5">
                        <div className="flex flex-row items-center justify-start gap-1.5">
                          <div className="relative font-semibold">
                            Default content
                          </div>
                          <img
                            className="w-5 relative h-5 overflow-hidden shrink-0"
                            alt=""
                            src="assets/help-circle.svg"
                          />
                        </div>
                        <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border h-[282px] flex flex-col items-start justify-start p-4 gap-6 text-base">
                          <div className="flex flex-row items-center justify-start gap-2.5">
                            <div className="flex flex-row items-center justify-start gap-2.5">
                              <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-center justify-center py-2.5 px-3.5 gap-1.5">
                                <div className="relative font-semibold">
                                  Inter
                                </div>
                                <img
                                  className="w-5 relative h-5 overflow-hidden shrink-0"
                                  alt=""
                                  src="assets/arrow-down-font.svg"
                                />
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M21.332 7.921c-.41 0-.75-.34-.75-.75v-1.82c0-.73-.59-1.32-1.32-1.32H4.742c-.73 0-1.32.59-1.32 1.32v1.83c0 .41-.34.75-.75.75s-.75-.34-.75-.76v-1.82c0-1.56 1.27-2.82 2.82-2.82h14.52c1.56 0 2.82 1.27 2.82 2.82v1.83c0 .41-.33.74-.75.74Z"
                                  fill="#2d404e"
                                ></path>
                                <path
                                  d="M12 21.47c-.41 0-.75-.34-.75-.75V4.11c0-.41.34-.75.75-.75s.75.34.75.75v16.61c0 .42-.34.75-.75.75Z"
                                  fill="#2d404e"
                                ></path>
                                <path
                                  d="M15.939 21.469h-7.88c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.88c.41 0 .75.34.75.75s-.34.75-.75.75Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                            </div>
                            <div className="flex flex-row items-start justify-start gap-2.5">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M11.999 12.75h-7.12c-.41 0-.75-.34-.75-.75V4.5c0-1.52 1.23-2.75 2.75-2.75h5.12c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5Zm-6.38-1.5h6.38c2.21 0 4-1.79 4-4s-1.79-4-4-4h-5.12c-.69 0-1.25.56-1.25 1.25v6.75h-.01Z"
                                  fill="#2d404e"
                                ></path>
                                <path
                                  d="M14.379 22.25h-7.5c-1.52 0-2.75-1.23-2.75-2.75V12c0-.41.34-.75.75-.75h9.5c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5Zm-8.76-9.5v6.75c0 .69.56 1.25 1.25 1.25h7.5c2.21 0 4-1.79 4-4s-1.79-4-4-4h-8.75Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M19 21.75H5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h14c.41 0 .75.34.75.75s-.34.75-.75.75ZM12 17.75c-4.27 0-7.75-3.48-7.75-7.75V3c0-.41.34-.75.75-.75s.75.34.75.75v7c0 3.45 2.8 6.25 6.25 6.25s6.25-2.8 6.25-6.25V3c0-.41.34-.75.75-.75s.75.34.75.75v7c0 4.27-3.48 7.75-7.75 7.75Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M18.879 3.75h-9.26c-.41 0-.74-.34-.74-.75s.34-.75.75-.75h9.25c.41 0 .75.34.75.75s-.34.75-.75.75ZM14.381 21.75h-9.26c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.25c.41 0 .75.34.75.75s-.33.75-.74.75Z"
                                  fill="#2d404e"
                                ></path>
                                <path
                                  d="M9.748 21.748c-.06 0-.12-.01-.18-.02-.4-.1-.65-.51-.55-.91l4.5-18a.75.75 0 1 1 1.46.36l-4.5 18c-.09.34-.39.57-.73.57Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M21 5.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM12.47 10.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.47a.749.749 0 1 1 0 1.5ZM21 15.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM12.47 20.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.47a.749.749 0 1 1 0 1.5Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M21 5.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM21.001 10.25h-9.47c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.47c.41 0 .75.34.75.75s-.34.75-.75.75ZM21 15.25H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75ZM21.001 20.25h-9.47c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9.47c.41 0 .75.34.75.75s-.34.75-.75.75Z"
                                  fill="#2d404e"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <div className="relative text-Neutrals-neutral-300">
                            Enter text for the email
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-row items-center justify-start gap-6 text-base">
                        {/* Block 1 */}
                        <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-col items-start justify-start p-6 gap-6">
                          <div className="self-stretch flex flex-row items-start justify-between gap-0">
                            <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] flex flex-row items-start justify-start p-2.5">
                              <img
                                className="w-5 relative h-5"
                                alt=""
                                src="assets/timer.svg"
                              />
                            </div>
                            {/* Toggle */}
                            <Toggle
                              onToggle={handleToggle}
                              isOn={true}
                              onColor="bg-primary-primary-500"
                              offColor="bg-primary-primary-50"
                              knobColor="bg-neutrals-neutral-50"
                            />
                          </div>
                          <div className="flex flex-col items-start justify-start gap-1.5">
                            <div className="relative font-semibold">
                              Status tracking
                            </div>
                            <div className="w-[294px] relative text-neutrals-neutral-300 inline-block">
                              Track the status of the Pre-LBA and get notified
                              about changes.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Frequency setting */}
                  <div className="flex flex-col items-start justify-start gap-6">
                    <div className="relative font-semibold">
                      Frequency settings
                    </div>
                    <div className="flex flex-row items-start justify-start gap-6">
                      <RadioButton options={["Daily", "Weekly", "Monthly"]} />
                    </div>
                  </div>

                  <div className="self-stretch relative border-neutrals-neutral-100 border-solid border-t-[1px] box-border h-px" />

                  {/* Delivery option */}
                  <div className="flex flex-col items-start justify-start gap-6">
                    <div className="relative font-semibold">
                      Delivery option
                    </div>
                    <div className="flex flex-row items-start justify-start gap-6">
                      <RadioButton
                        options={["Third party", "In-house post machines"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {isToastMsgOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeToastMsg}
        >
          <ToastMsg onClose={closeToastMsg} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default SettingsLBAConfigPage;
